
import AuthenticationManager from "./AuthenticationManager";
import {useEffect} from 'react';

export default function SEPassportAuthenticationCallback(props) {

    useEffect(() => {
        AuthenticationManager.signinRedirectCallback()
            .then(() => {
                // redirect to route
                window.location = window.location.origin;
            })
            .catch(function(e) {
                console.error('sign in error');
                console.error(e);
            });
    });
    

    return null;
}
